import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { takePostAuthRedirect } from '../utils/auth';
import '../styles/auth.css';

export default function VerifyPending() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem('adeeb-user');
    const token = localStorage.getItem('adeeb-token');
    if (!raw || !token) {
      navigate('/login', { replace: true });
      return;
    }
    const u = JSON.parse(raw);
    if (u.emailVerified) {
      navigate(takePostAuthRedirect() || '/', { replace: true });
      return;
    }
    setUser(u);
  }, [navigate]);

  const resend = async () => {
    setStatus('');
    setError('');
    setBusy(true);
    try {
      const token = localStorage.getItem('adeeb-token');
      await axios.post(
        '/api/auth/resend-verification',
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStatus('Verification email sent. Check your inbox.');
    } catch (err) {
      setError(err?.response?.data?.message || 'Could not resend the email. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  const signOut = async () => {
    try { await axios.post('/api/auth/logout'); } catch { return; }
    localStorage.removeItem('adeeb-token');
    localStorage.removeItem('adeeb-user');
    window.dispatchEvent(new Event('adeeb-auth-change'));
    navigate('/login', { replace: true });
  };

  return (
    <div className="auth-wrapper">
      <Link to="/" className="floating-back-btn">&#8592; Library</Link>
      <div className="auth-bg-ornament" aria-hidden="true">&#10040; &#10040; &#10040;</div>
      <div className="auth-card">
        <Link to="/" className="auth-logo"><img className="auth-brand-image" src="/branding/deenlit-logo.png" alt="DeenLit" width="2172" height="724" /></Link>
        <p className="auth-tagline">One last step</p>
        <h2 style={{ marginTop: 8, textAlign: 'center' }}>Verify your email</h2>
        <p style={{ textAlign: 'center', lineHeight: 1.55 }}>
          We sent a verification link to{' '}
          <strong>{user?.email || 'your email'}</strong>. Open it to unlock the
          library and start reading.
        </p>
        {status && <div className="auth-success" role="status" style={{ marginTop: 12 }}>{status}</div>}
        {error && <div className="auth-error" role="alert" style={{ marginTop: 12 }}>{error}</div>}
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <button
            type="button"
            className="auth-submit"
            onClick={resend}
            disabled={busy}
            style={{ display: 'inline-block', width: 'auto' }}
          >
            {busy ? 'Sending…' : 'Resend verification email'}
          </button>
        </div>
        <p className="auth-switch" style={{ marginTop: 16 }}>
          Wrong account?{' '}
          <button type="button" className="auth-link auth-link-btn" onClick={signOut}>
            Sign out
          </button>
        </p>
      </div>
    </div>
  );
}
